import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQ = [
  {
    q: "Wat is Privacy Smart Film?",
    a: "Privacy Smart Film is slimme folie die op glas wordt aangebracht en het glas met één klik transparant of mat maakt.",
  },
  {
    q: "Blijft er licht binnen?",
    a: "Ja. De film zorgt voor privacy terwijl natuurlijk licht behouden blijft.",
  },
  {
    q: "Voor wie is dit geschikt?",
    a: "Voor woningen, badkamers, kantoren, vergaderruimtes, praktijkruimtes, winkels, horeca en showrooms.",
  },
  {
    q: "Kunnen jullie ook installeren?",
    a: "Ja, JYNOVA voorziet advies, levering en installatie afhankelijk van het project.",
  },
  {
    q: "Wat kost het?",
    a: "Privacy Smart Film start vanaf €199/m² exclusief installatie. De exacte prijs hangt af van afmetingen, toepassing, type glas, elektrische aansluiting en technische situatie. LED / Display Film is prijs op aanvraag voor B2B-projecten.",
  },
  {
    q: "Werken jullie ook voor bedrijven?",
    a: "Ja. We werken voor kantoren, showrooms, winkels, horeca, praktijken en andere commerciële ruimtes.",
  },
  {
    q: "Is dit geschikt voor bestaand glas?",
    a: "In veel gevallen wel. We bekijken dit per project op basis van type glas, afmetingen en toepassing.",
  },
  {
    q: "Hoe wordt de film bediend?",
    a: "Afhankelijk van de gekozen oplossing kan bediening via schakelaar, afstandsbediening of slimme sturing.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      className="relative py-24 md:py-32 bg-black/30"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="mb-14 text-center">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400 mb-4">
            FAQ
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight">
            Veelgestelde vragen.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQ.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-heading text-lg md:text-xl text-white hover:text-cyan-400 hover:no-underline py-6 font-medium">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 font-body text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
